/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Hide_Event_AriaInputs */



/**
* | output |
* | --- |
* | "Hide Event Shortcut" |
*
* @param {Timing_Sync_Hide_Event_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_hide_event_aria = /** @type {((inputs?: Timing_Sync_Hide_Event_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Hide_Event_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Raccourci masquer l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verknüpfung zum Ereignis ausblenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nascondi collegamento evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скрыть ярлык события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ocultar acceso directo a eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("隐藏事件快捷方式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントのショートカットを非表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट शॉर्टकट छिपाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atalho para ocultar evento")
	return /** @type {LocalizedString} */ ("Hide Event Shortcut")
});